import appSettings from "../settings/appSettings";
import fetchRequest from "./fetchRequest";
import { wvusLogger } from "../helpers";
const { orderApiConfig } = appSettings;

class OrderApiError extends Error {
  response: {
    message?: string;
  };
  status: number;
}

const parseErrorResponse = (jsonStr: string, defaultErrorMessage: string = "Invalid response") => {
  if (typeof jsonStr !== "string") {
    return { message: defaultErrorMessage };
  }

  try {
    const parsedJson = JSON.parse(jsonStr);
    return parsedJson || { message: defaultErrorMessage };
  } catch {
    return { message: jsonStr };
  }
};

const handleErrorResponse = async (errorResponse: Response): Promise<OrderApiError> => {
  const parsedErrorResponse = await errorResponse.text().then(parseErrorResponse);
  const err = new OrderApiError(
    `${errorResponse.status} ${errorResponse.statusText}: ${parsedErrorResponse.message}`
  );
  err.response = parsedErrorResponse;
  err.status = errorResponse.status;
  return err;
};

export const isPaymentAuthError = (error) => {
  if (
    error &&
    error?.response?.worldPayOrderId &&
    error?.response?.responseCode &&
    error?.response?.errorType === "user"
  ) {
    return true;
  }

  return false;
};

export const requestOrderApi = async (apiPayload) => {
  const baseUrl = orderApiConfig.baseUrl;
  const url = `${baseUrl}/api/orders/create`;

  try {
    const response = await fetchRequest(url, {
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      timeout: 45 * 1000,
      headers: {
        "x-subscription-key": `${orderApiConfig.subscriptionKey}`,
        "content-type": "application/json"
      },
      body: JSON.stringify(apiPayload),
      credentials: "include"
    });

    if (!response.ok) {
      // This will throw an Error object
      throw await handleErrorResponse(response);
    }

    const orderResp = await response.json();

    if (
      !orderResp ||
      !orderResp.success ||
      !orderResp?.data?.orderId ||
      !orderResp?.data?.orderRef
    ) {
      const err = new OrderApiError("Invalid order response.");
      err.response = (orderResp && orderResp) || "";
      throw err;
    }

    return orderResp;
  } catch (err) {
    wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
    return Promise.reject(err);
  }
};
